import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{attrs:{"src":require("@/assets/flightradar-192x192.png"),"eager":"","max-width":"20","max-height":"20"}})
}
var staticRenderFns = []

export { render, staticRenderFns }